import React , { Component } from 'react';
import Radium, {Style} from 'radium';


class MainMenuToggler extends Component {
  
    render() {
        return (
            <button type="button" id="main-menu-toggle" className="navbar-toggle">
                <Style
                    rules={{
                        '#main-menu-toggle': {
                            marginLeft: "10px",
                            marginRight: 0,
                            border: "none",
                            float: "left"
                        },
                        '#main-menu-toggle:hover, #main-menu-toggle:focus': {
                            backgroundColor: "transparent !important"
                        },
                        '#main-menu-toggle:hover .icon-bar, #main-menu-toggler:focus .icon-bar': {
                            backgroundColor: "white",
                        }
                    }}>
                </Style>
                <span className="sr-only"> Toggle navigation </span>
                <span className="icon-bar" />
                <span className="icon-bar" />
                <span className="icon-bar" />
            </button>
        )
    }
}

export default Radium(MainMenuToggler);



// WEBPACK FOOTER //
// ./src/components/Header/MainMenuToggler.js